import { useState } from "react";
import Papa from 'papaparse';





const formattedData = [];




export const extractUniqueDates = (data) => {
    const uniqueDates = new Set(); // Set will automatically handle uniqueness
    data.forEach(record => {
        const startDate = record.start_time;
        uniqueDates.add(startDate);
    });
    return Array.from(uniqueDates); // Convert Set to array
};


export const extractUniqueExerciseTitle = (data) => {
    const uniqueExerciseTitle = new Set(); // Set will automatically handle uniqueness
    data.forEach(record => {
        uniqueExerciseTitle.add(record.exercise_title.trim()); // Add exercise title
    });
    return Array.from(uniqueExerciseTitle); // Convert Set to array
};


const handleCsvUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
        if (file.type !== 'text/csv') {
            //  setError('Please upload a valid CSV file');
            return;
        }

        Papa.parse(file, {
            complete: (results) => {
                try {
                    const processedData = results.data.map((row) => ({
                        ...row,
                        // Parse integers
                        superset_id: row.superset_id ? parseInt(row.superset_id, 10) : null,
                        set_index: row.set_index ? parseInt(row.set_index, 10) : null,
                        reps: row.reps ? parseInt(row.reps, 10) : null,
                        duration_seconds: row.duration_seconds ? parseInt(row.duration_seconds, 10) : null,
                        // Parse floats
                        weight_kg: row.weight_kg ? parseFloat(row.weight_kg) : null,
                        rpe: row.rpe ? parseFloat(row.rpe) : null,
                    }));
                    return processedData;
                    // setError('');
                } catch (error) {
                    // setError('Error processing CSV data: ' + error.message);
                }
            },
            header: true,
            skipEmptyLines: true,
            error: (error) => {
                //   setError('Error parsing CSV: ' + error.message);
            },
        });
    }
};



const convertToISO8601 = (dateString) => {
    const dateParts = dateString.split(", "); // Split the string into two parts
    const date = dateParts[0].split(" "); // Split the first part into three parts
    const time = dateParts[1].split(":"); // Split the second part into two parts
    const year = date[2]; // Extract the year as a string
    const month = date[1]; // Extract the month as a string
    const day = date[0]; // Extract the day as a string
    const hours = time[0]; // Extract the hours as a string
    const minutes = time[1]; // Extract the minutes as a string

    // Create a new Date object with the year, month, day, hours, and minutes
    const dateObject = new Date(
        parseInt(year),
        monthToNumber(month),
        parseInt(day),
        parseInt(hours),
        parseInt(minutes)
    );

    // Return the ISO8601 date object string
    return dateObject.toISOString();
};

const monthToNumber = (monthString) => {
    const months = {
        Jan: 1,
        Feb: 2,
        Mar: 3,
        Apr: 4,
        May: 5,
        Jun: 6,
        Jul: 7,
        Aug: 8,
        Sep: 9,
        Oct: 10,
        Nov: 11,
        Dec: 12,
    };

    return months[monthString];
};









//---------------------------------------------------------------------------------------

export async function convert_csv_to_data(csvData) {

    const UniqueDates = extractUniqueDates(csvData);
    //onsole.log('Unique Dates:', extractUniqueDates(csvData));

    UniqueDates.forEach(date => { //loop 1

        // console.log('Starting Loop 1 for Date:', date);

        const dataForSpecificDate = csvData.filter(row => row.start_time.startsWith(date)); //data filtered by the date in the loop
        //console.log('Data For Specific Date:', dataForSpecificDate);

        const exercisesDoneOnThatDay = extractUniqueExerciseTitle(dataForSpecificDate); // Find unique exercises done on that specific day

        //console.log('Exercises Done on That Day:', exercisesDoneOnThatDay);

        let start_time = '';
        let title = '';
        let end_time = '';
        let description = '';
        let exercise_title = '';
        let set_index = '';
        let set_type = '';
        let weight_kg = 0;
        let reps = 0;
        let temp = {}

        exercisesDoneOnThatDay.forEach(exercise => { //loop 2

            //console.log('Starting Loop 2 for Exercise:', exercise);

            const rows_for_correspond_specific_exercise = dataForSpecificDate.filter(row => row.exercise_title === exercise); // Find the number of rows for each exercise on that date

            //console.log('Rows for Correspond Specific Exercise:', rows_for_correspond_specific_exercise);



            for (let set_indexvalue = 0; set_indexvalue < 100; set_indexvalue++) { //loop 3

                //console.log('Starting Loop 3 for Set Index:', sex_indexvalue);

                const target_row_matching_set_index = rows_for_correspond_specific_exercise.find(row => row.set_index === set_indexvalue);

                //console.log('target_row_matching_set_index:', target_row_matching_set_index);



                if (!target_row_matching_set_index) {  //if target_row_matching_set_index is undefined, break the loop
                    break;
                } else {

                    if (set_indexvalue == 0) {


                        start_time = convertToISO8601(target_row_matching_set_index.start_time); // Start time is the same for all rows
                        title = target_row_matching_set_index.title;
                        end_time = convertToISO8601(target_row_matching_set_index.end_time); // End time is the same for all rows
                        description = target_row_matching_set_index.description;
                        exercise_title = target_row_matching_set_index.exercise_title;
                        set_index = target_row_matching_set_index.set_index;
                        set_type = target_row_matching_set_index.set_type;
                        weight_kg = target_row_matching_set_index.weight_kg;
                        reps = target_row_matching_set_index.reps;


                        temp = {
                            title: title,
                            start_time: start_time,
                            end_time: end_time,
                            description: description,
                            exercise_title: exercise_title,
                            sets: [{
                                set_index: set_index,
                                set_type: set_type,
                                weight_kg: weight_kg,
                                reps: reps
                            }]

                        };


                    } else {

                        set_index = target_row_matching_set_index.set_index;
                        set_type = target_row_matching_set_index.set_type;
                        weight_kg = target_row_matching_set_index.weight_kg;
                        reps = target_row_matching_set_index.reps;


                        temp.sets.push({
                            set_index: set_index,
                            set_type: set_type,
                            weight_kg: weight_kg,
                            reps: reps
                        });


                    }


                }


            }


            formattedData.push(temp);
           




        });

       




    });

    console.log('formattedData Final:', formattedData);

    return formattedData;

}


